import { Component, OnDestroy, OnInit } from '@angular/core';

import { DynamicHtmlDirective } from '@frontend/vanilla/core';
import { TranslateModule } from '@ngx-translate/core';
import { Subscription } from 'rxjs';

import { MessageType } from '../../../../model/message.model';
import { BehaviorDataService } from '../../../../service/behaviorData.service';
import { GtmService } from '../../../../service/gtm.service';
import { OptionListService } from '../../../../service/optionList.service';
import { UserDataService } from '../../../../service/userDataService';
import { MessageComponent } from '../../../../shared/components/messages/message-component';

@Component({
    selector: 'app-arc-message',
    templateUrl: 'arc-message.component.html',
    imports: [MessageComponent, TranslateModule, DynamicHtmlDirective],
})
export class ARCMessageComponent implements OnInit, OnDestroy {
    arcDepositBlockStatus: any;
    tempObj: { [k: string]: any } = {};
    arcDeclinedDepositClickHereUrl: string;
    subscriptions$: Subscription[] = [];
    showChatNotAvailable = false;
    public get messageType(): typeof MessageType {
        return MessageType;
    }
    constructor(
        private userDataService: UserDataService,
        private optionListService: OptionListService,
        private behaviorData: BehaviorDataService,
        private gtmService: GtmService,
    ) {}

    ngOnInit(): void {
        if (this.userDataService?.userData?.userInfo) {
            this.arcDepositBlockStatus = this.userDataService?.userData?.userInfo?.userARCDeclinedDepositStatus;
            this.arcDeclinedDepositClickHereUrl = this.userDataService?.userData?.configParams?.arcDeclinedDepositClickHereUrl;
            if (this.arcDepositBlockStatus && this.arcDepositBlockStatus?.depositBlocked) {
                const eventData = { component: this.tempObj };
                eventData.component.CategoryEvent = 'cashier';
                eventData.component.LabelEvent = 'high volume deposit declines - deposit blocked';
                eventData.component.ActionEvent = 'click';
                eventData.component.LocationEvent = 'quick deposit';
                eventData.component.EventDetails = 'high volume deposit declines - blocked message';
                eventData.component.URLClicked = 'not applicable';
                this.gtmService.raiseComponentEvent('Event.Tracking', eventData);
                this.optionListService.redirectToMainCashier();
            }
        }

        this.subscriptions$.push(
            this.behaviorData.getArcDepositBlockStatus.subscribe((data) => {
                this.arcDepositBlockStatus = data;
            }),
        );
    }

    ngOnDestroy() {
        this.subscriptions$.map((subscription) => subscription.unsubscribe());
    }
}
